import React from "react"
import { Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerBody } from "@chakra-ui/react"
import ReviewAddHeader from "@app/components/Product/Review/Add/ReviewAddHeader"
import { ReviewAddForm } from "@app/components/Product/Review/Add/ReviewAddForm"
import { ProductCombinedProps, ProductProps } from "@root/types/global"
type Props = {
  isOpen: boolean
  onClose: () => void
  width: number
  product: ProductCombinedProps
  swatches?: Array<ProductProps>
}

const ReviewAddDrawer = ({ isOpen, onClose, width, product, swatches }: Props) => {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} blockScrollOnMount={width === 0} size="lg">
      <DrawerOverlay backdropFilter="none" backgroundColor="rgba(0, 0, 0, 0.4)" />
      <DrawerContent>
        <DrawerCloseButton />
        <ReviewAddHeader product={product} swatches={swatches} />

        <DrawerBody display="flex" flexDir="column" background="grey.cloud" p={0}>
          <ReviewAddForm product={product} onClose={onClose} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default ReviewAddDrawer
